import { render, staticRenderFns } from "./modalAddSecurityGroupRules.vue?vue&type=template&id=563dd66f&"
import script from "./modalAddSecurityGroupRules.vue?vue&type=script&lang=js&"
export * from "./modalAddSecurityGroupRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports